import React, { useEffect, useMemo, useState, } from "react";

import apiService from "../services/apiService";

import I from "./Icon";

import BC from "./Breadcrumb";

const ADD_SCHOOL_API_URL =

  "School/addSchool";

const UPDATE_SCHOOL_API_URL =

  "School/updateSchool";

const DISTRICT_API_URL =

  "DistrictMaster/getAllDistrictMasters?includeInActive=true";

const TALUKA_API_URL =

  "TalukaMaster/getAllTalukaMasters?includeInActive=true";

const ADD_DISTRICT_API_URL =

  "DistrictMaster/addDistrictMaster";

const ADD_TALUKA_API_URL =

  "TalukaMaster/addTalukaMaster";

const getHeaders = () => {

  const token =

    sessionStorage.getItem("token") ||

    localStorage.getItem("token");

  const headers = {

    Accept: "application/json",

  };

  if (token) {

    headers.Authorization = `Bearer ${token}`;

  }

  return headers;

};

const extractArray = (result) => {

  if (Array.isArray(result)) {

    return result;

  }

  const output =

    result?.output ??

    result?.Output ??

    result?.data ??

    result?.Data ??

    result;

  if (Array.isArray(output)) {

    return output;

  }

  const nested =

    output?.result ??

    output?.Result ??

    output?.data ??

    output?.Data ??

    [];

  return Array.isArray(nested)

    ? nested

    : [];

};

const normalizeDistrict = (district) => {

  return {

    ...district,

    id: Number(

      district?.id ??

      district?.Id ??

      district?.districtId ??

      district?.DistrictId ??















      district?.districtMasterId ??















      district?.DistrictMasterId ??















      0















    ),































    name:















      district?.districtName ??















      district?.DistrictName ??















      district?.districtMasterName ??















      district?.DistrictMasterName ??















      district?.district ??















      district?.District ??















      district?.name ??















      district?.Name ??















      "",































    stateId: Number(















      district?.stateId ??















      district?.StateId ??















      district?.stateMasterId ??















      district?.StateMasterId ??















      0















    ),































    isActive:















      district?.isActive ??















      district?.IsActive ??















      true,















  };















};































const normalizeTaluka = (taluka) => {















  return {















    ...taluka,































    id: Number(















      taluka?.id ??















      taluka?.Id ??















      taluka?.talukaId ??















      taluka?.TalukaId ??















      taluka?.talukaMasterId ??















      taluka?.TalukaMasterId ??















      0















    ),































    name:















      taluka?.talukaName ??















      taluka?.TalukaName ??















      taluka?.talukaMasterName ??















      taluka?.TalukaMasterName ??















      taluka?.taluka ??















      taluka?.Taluka ??















      taluka?.name ??















      taluka?.Name ??















      "",































    districtId: Number(















      taluka?.districtId ??















      taluka?.DistrictId ??















      taluka?.districtMasterId ??















      taluka?.DistrictMasterId ??















      0















    ),































    isActive:















      taluka?.isActive ??















      taluka?.IsActive ??















      true,















  };















};































const getPincodeValue = (data) => {















  if (!data) return "";































  const findPincode = (obj, depth = 0) => {















    if (















      !obj ||















      typeof obj !== "object" ||















      depth > 5















    ) {















      return "";















    }































    for (const [key, value] of Object.entries(obj)) {















      const normalizedKey = key















        .replace(/[****\\\**_**\s-]/g, "")















        .toLowerCase();































      const isPincodeKey =















        normalizedKey.includes("pincode") ||















        normalizedKey.includes("postalcode") ||















        normalizedKey.includes("zipcode");































      if (isPincodeKey) {















        if (















          value !== null &&















          value !== undefined &&















          value !== "" &&















          Number(value) !== 0















        ) {















          return String(value);















        }















      }















    }































    for (const value of Object.values(obj)) {















      if (















        value &&















        typeof value === "object"















      ) {















        const found =















          findPincode(value, depth + 1);































        if (found) {















          return found;















        }















      }















    }































    return "";















  };































  return findPincode(data);















};































const getSchoolId = (data) => {















  return Number(















    data?.id ??















    data?.Id ??















    data?.schoolId ??















    data?.SchoolId ??















    data?.schoolMasterId ??















    data?.SchoolMasterId ??















    0















  );















};































const makeFormState = (initial) => {















  return {















    name:















      initial?.name ??















      initial?.schoolName ??















      initial?.SchoolName ??















      "",































    code:















      initial?.code ??















      initial?.schoolCode ??















      initial?.SchoolCode ??















      "",































    state:















      initial?.state ??















      initial?.State ??















      initial?.stateName ??















      initial?.StateName ??















      "Maharashtra",































    stateId:















      initial?.stateId ??















      initial?.StateId ??















      initial?.stateMasterId ??















      initial?.StateMasterId ??















      0,































    districtId:















      initial?.districtId ??















      initial?.DistrictId ??















      initial?.districtMasterId ??















      initial?.DistrictMasterId ??















      "",































    talukaId:















      initial?.talukaId ??















      initial?.TalukaId ??















      initial?.talukaMasterId ??















      initial?.TalukaMasterId ??















      "",































    address:















      initial?.address ??















      initial?.Address ??















      "",































    pincode:















      getPincodeValue(initial),































    phone:















      initial?.phone ??















      initial?.Phone ??















      initial?.phoneNumber ??















      initial?.PhoneNumber ??















      "",































    status:















      initial?.isActive === false ||















        initial?.IsActive === false ||















        initial?.status === false ||















        initial?.status === "inactive"















        ? "inactive"















        : "active",















  };















};































const parseResponse = (text) => {















  if (!text) {















    return null;















  }































  try {















    return JSON.parse(text);















  } catch {















    return text;















  }















};































const showNotification = (type, message) => {







  if (







    typeof document === "undefined" ||







    typeof window === "undefined"







  ) {







    return;







  }















  const existingNotification =







    document.getElementById(







      "school-form-notification"







    );















  if (existingNotification) {







    existingNotification.remove();







  }















  const notification =







    document.createElement("div");















  notification.id =







    "school-form-notification";















  notification.textContent =







    `${type === "success" ? "✓" : "✕"} ${message}`;















  Object.assign(







    notification.style,







    {







      position: "fixed",







      top: "20px",







      right: "20px",







      zIndex: "99999",







      minWidth: "280px",







      maxWidth: "420px",







      padding: "12px 16px",







      borderRadius: "8px",







      backgroundColor:







        type === "success"







          ? "#d1e7dd"







          : "#f8d7da",







      color:







        type === "success"







          ? "#0f5132"







          : "#842029",







      border:







        type === "success"







          ? "1px solid #badbcc"







          : "1px solid #f5c2c7",







      fontSize: "14px",







      fontWeight: "600",







      boxShadow:







        "0 4px 12px rgba(0,0,0,0.15)",







    }







  );















  document.body.appendChild(







    notification







  );















  window.setTimeout(() => {







    if (notification.parentNode) {







      notification.remove();







    }







  }, 3000);







};























const getErrorMessage = (















  result,















  fallback















) => {















  if (















    typeof result === "string" &&















    result.trim()















  ) {















    return result;















  }































  if (















    result &&















    typeof result === "object"















  ) {















    if (















      result?.errors &&















      typeof result.errors === "object"















    ) {















      const validationErrors =















        Object.values(result.errors)















          .flat()















          .filter(Boolean)















          .join(" ");































      if (validationErrors) {















        return validationErrors;















      }















    }































    return (















      result?.message ||















      result?.Message ||















      result?.failureReason ||















      result?.FailureReason ||















      result?.title ||















      result?.error ||















      fallback















    );















  }































  return fallback;















};































export default function SchoolForm({







  title,







  initial,







  onSave,







  onBack,







}) {















const schoolId =















    getSchoolId(initial);































  const isEdit =















    schoolId > 0;































  const [f, setF] = useState(















    () => makeFormState(initial)















  );































  const [















    districts,















    setDistricts,















  ] = useState([]);































  const [















    talukas,















    setTalukas,















  ] = useState([]);







  const [addDistrictOpen, setAddDistrictOpen] = useState(false);



  const [addTalukaOpen, setAddTalukaOpen] = useState(false);



  const [newDistrict, setNewDistrict] = useState("");



  const [newTaluka, setNewTaluka] = useState("");



  const [districtSaving, setDistrictSaving] = useState(false);



  const [talukaSaving, setTalukaSaving] = useState(false);































  const [















    loadingDistricts,















    setLoadingDistricts,















  ] = useState(false);































  const [















    loadingTalukas,















    setLoadingTalukas,















  ] = useState(false);































  const [















    saving,















    setSaving,















  ] = useState(false);































  const [















    error,















    setError,















  ] = useState("");

  const [fieldErrors, setFieldErrors] = useState({});































  const s = (key, value) => {
    setF((previous) => ({
      ...previous,
      [key]: value,
    }));

    setFieldErrors((previous) => {
      const updated = { ...previous };
      delete updated[key];
      return updated;
    });
  };

  useEffect(() => {















    if (!initial) {















      return;















    }































    console.log(















      "EDIT SCHOOL INITIAL DATA:",















      initial















    );































    console.log(















      "EDIT SCHOOL PINCODE:",















      getPincodeValue(initial)















    );































    setF(















      makeFormState(initial)















    );































  }, [initial]);































  useEffect(() => {















    const controller =















      new AbortController();































    const loadDistricts =















      async () => {































        try {































          setLoadingDistricts(true);































          const response = await apiService.get(















            DISTRICT_API_URL















          );































          const result = response.data;































          const districtData =















            extractArray(result)















              .map(















                normalizeDistrict















              )















              .filter(















                (district) =>















                  district.id > 0 &&















                  district.name















              );































          console.log(















            "District Data:",















            districtData















          );































          setDistricts(















            districtData















          );































        } catch (err) {































          if (















            err?.name ===















            "AbortError"















          ) {















            return;















          }































          console.error(















            "District Load Error:",















            err















          );































          setDistricts([]);































          showNotification(







            "error",







            err?.message ||







              "Unable to load districts."







          );































        } finally {































          if (















            !controller















              .signal















              .aborted















          ) {















            setLoadingDistricts(















              false















            );















          }















        }















      };































    loadDistricts();































  return () => {















      controller.abort();















    };































  }, []);































  useEffect(() => {















    const controller =















      new AbortController();































    const loadTalukas =















      async () => {































        try {































          setLoadingTalukas(















            true















          );































          const response = await apiService.get(















            TALUKA_API_URL















          );































          const result = response.data;































          const talukaData =















            extractArray(result)















              .map(















                normalizeTaluka















              )















              .filter(















                (taluka) =>















                  taluka.id > 0 &&















                  taluka.name















              );































          console.log(















            "Taluka Data:",















            talukaData















          );































          setTalukas(















            talukaData















          );































        } catch (err) {































          if (















            err?.name ===















            "AbortError"















          ) {















            return;















          }































          console.error(















            "Taluka Load Error:",















            err















          );































          setTalukas([]);































          showNotification(







            "error",







            err?.message ||







              "Unable to load talukas."







          );































        } finally {































          if (















            !controller















              .signal















              .aborted















          ) {















            setLoadingTalukas(















              false















            );















          }















        }















      };































    loadTalukas();































    return () => {















      controller.abort();















    };































  }, []);































  useEffect(() => {































    if (















      !f.districtId ||















      Number(f.stateId) > 0 ||















      districts.length === 0















    ) {















      return;















    }































    const selectedDistrict =















      districts.find(















        (district) =>















          Number(















            district.id















          ) ===















          Number(















            f.districtId















          )















      );































    if (















      selectedDistrict?.stateId















    ) {































      setF(















        (previous) => ({















          ...previous,































          stateId:















            selectedDistrict















              .stateId,















        })















      );















    }































  }, [















    districts,















    f.districtId,















    f.stateId,















  ]);































  const currentTalukas =















    useMemo(() => {































      if (!f.districtId) {















        return [];















      }































      const selectedDistrictId =















        Number(















          f.districtId















        );































      return talukas.filter(















        (taluka) =>















          Number(















            taluka.districtId















          ) ===















          selectedDistrictId















      );































    }, [















      talukas,















      f.districtId,















    ]);















  const handleDistrictChange =















    (event) => {































      const districtId =















        event.target.value;







      if (districtId === "__add_district__") {



        setAddDistrictOpen(true);



        return;



      }































      const selectedDistrict =















        districts.find(















          (district) =>















            Number(















              district.id















            ) ===















            Number(















              districtId















            )















        );































      setF(















        (previous) => ({















          ...previous,































          districtId,















          talukaId: "",































          stateId:















            selectedDistrict















              ?.stateId ??















            previous.stateId,















        })















      );















    };







  const reloadDistricts = async () => {



    const response = await apiService.get(DISTRICT_API_URL);



    const result = response.data;







    const districtData = extractArray(result)



      .map(normalizeDistrict)



      .filter(



        (district) =>



          district.id > 0 &&



          district.name



      );







    setDistricts(districtData);



    return districtData;



  };







  const reloadTalukas = async () => {



    const response = await apiService.get(TALUKA_API_URL);



    const result = response.data;







    const talukaData = extractArray(result)



      .map(normalizeTaluka)



      .filter(



        (taluka) =>



          taluka.id > 0 &&



          taluka.name



      );







    setTalukas(talukaData);



    return talukaData;



  };







  const handleAddDistrict = async () => {



    const districtName = newDistrict.trim();







    if (!districtName) {



      showNotification(



        "error",



        "Please enter district name."



      );



      return;



    }







    try {



      setDistrictSaving(true);







      const payload = {



        districtName,



        stateId: Number(f.stateId) || 1,



        isActive: 1,



      };







      const response = await apiService.post(



        ADD_DISTRICT_API_URL,



        payload



      );







      const result = response.data;







      const isSuccess =



        result?.isSuccess ??



        result?.IsSuccess ??



        true;







      const output =



        result?.output ??



        result?.Output;







      const outputStatus =



        output?.status ??



        output?.Status ??



        "";







      const outputMessage =



        output?.message ??



        output?.Message ??



        "";







      if (



        isSuccess === false ||



        String(outputStatus)



          .toLowerCase()



          .includes("duplicate")



      ) {



        throw new Error(



          outputMessage ||



          getErrorMessage(



            result,



            "Failed to add district."



          )



        );



      }







      const freshDistricts =



        await reloadDistricts();







      const addedDistrict =



        freshDistricts.find(



          (district) =>



            String(district.name)



              .trim()



              .toLowerCase() ===



            districtName.toLowerCase()



        );







      if (addedDistrict?.id) {



        setF((previous) => ({



          ...previous,



          districtId:



            String(addedDistrict.id),



          talukaId: "",



          stateId:



            addedDistrict.stateId ||



            previous.stateId ||



            1,



        }));



      }







      setNewDistrict("");



      setAddDistrictOpen(false);







      showNotification(



        "success",



        result?.message ||



          result?.Message ||



          "District added successfully!"



      );



    } catch (err) {



      showNotification(



        "error",



        getErrorMessage(



          err?.response?.data,



          err?.message ||



            "Unable to add district."



        )



      );



    } finally {



      setDistrictSaving(false);



    }



  };







  const handleAddTaluka = async () => {



    const talukaName = newTaluka.trim();







    if (!f.districtId) {



      showNotification(



        "error",



        "Please select district first."



      );



      return;



    }







    if (!talukaName) {



      showNotification(



        "error",



        "Please enter taluka name."



      );



      return;



    }







    try {



      setTalukaSaving(true);







      const payload = {



        talukaName,



        districtId: Number(f.districtId),



        isActive: 1,



      };







      const response = await apiService.post(



        ADD_TALUKA_API_URL,



        payload



      );







      const result = response.data;







      const isSuccess =



        result?.isSuccess ??



        result?.IsSuccess ??



        true;







      const output =



        result?.output ??



        result?.Output;







      const outputStatus =



        output?.status ??



        output?.Status ??



        "";







      const outputMessage =



        output?.message ??



        output?.Message ??



        "";







      if (



        isSuccess === false ||



        String(outputStatus)



          .toLowerCase()



          .includes("duplicate")



      ) {



        throw new Error(



          outputMessage ||



          getErrorMessage(



            result,



            "Failed to add taluka."



          )



        );



      }







      const freshTalukas =



        await reloadTalukas();







      const addedTaluka =



        freshTalukas.find(



          (taluka) =>



            Number(taluka.districtId) ===



              Number(f.districtId) &&



            String(taluka.name)



              .trim()



              .toLowerCase() ===



              talukaName.toLowerCase()



        );







      if (addedTaluka?.id) {



        s(



          "talukaId",



          String(addedTaluka.id)



        );



      }







      setNewTaluka("");



      setAddTalukaOpen(false);







      showNotification(



        "success",



        result?.message ||



          result?.Message ||



          "Taluka added successfully!"



      );



    } catch (err) {



      showNotification(



        "error",



        getErrorMessage(



          err?.response?.data,



          err?.message ||



            "Unable to add taluka."



        )



      );



    } finally {



      setTalukaSaving(false);



    }



  };







































  const validateForm = () => {
    const e = {};

    if (!String(f.name || "").trim()) {
      e.name = "School name is required.";
    }

    if (!f.districtId) {
      e.districtId = "District is required.";
    }

    if (!f.talukaId) {
      e.talukaId = "Taluka is required.";
    }

    if (f.pincode && !/^[0-9]{6}$/.test(String(f.pincode))) {
      e.pincode = "Pincode must contain exactly 6 digits.";
    }

    if (f.phone && !/^[0-9]{10}$/.test(String(f.phone))) {
      e.phone = "Phone number must contain exactly 10 digits.";
    }

    return e;
  };

  const handleSubmit =
    async () => {
      const validationErrors = validateForm();

      if (Object.keys(validationErrors).length > 0) {
        setFieldErrors(validationErrors);
        return;
      }

      setFieldErrors({});

      try {































        setSaving(true);































        setError("");































        const payload = {































          ...(isEdit && {















            schoolId:















              schoolId,































            id:















              schoolId,















          }),































          districtId:















            Number(















              f.districtId















            ),































          talukaId:















            Number(















              f.talukaId















            ),































          stateId:















            Number(















              f.stateId || 0















            ),































          schoolName:















            String(















              f.name || ""















            ).trim(),































          schoolCode:















            String(















              f.code || ""















            ).trim() || null,































          address:















            String(















              f.address || ""















            ).trim() || null,































          Pincode:















            f.pincode















              ? Number(















                f.pincode















              )















              : 0,































          phoneNumber:















            String(















              f.phone || ""















            ).trim() || null,































          emailId:















            initial?.emailId ??















            initial?.EmailId ??















            null,































          description:















            initial?.description ??















            initial?.Description ??















            null,































          isActive: isEdit















            ? (f.status === "active" ? 1 : 0)















            : f.status === "active",















        };















        const apiUrl =















          isEdit















            ? UPDATE_SCHOOL_API_URL















            : ADD_SCHOOL_API_URL;































        console.log(















          isEdit















            ? "Update School URL:"















            : "Add School URL:",















          apiUrl















        );































        console.log(















          isEdit















            ? "Update School Payload:"















            : "Add School Payload:",















          payload















        );































        let response;































        if (isEdit) {















          response = await apiService.put(















            UPDATE_SCHOOL_API_URL,















            payload















          );















        } else {















          response = await apiService.post(















            ADD_SCHOOL_API_URL,















            payload















          );















        }































        const result = response.data;































        console.log(















          isEdit















            ? "Update School Status:"















            : "Add School Status:",















          response.status















        );































        console.log(















          isEdit















            ? "Update School Response:"















            : "Add School Response:",















          result















        );































        const isSuccess = result?.isSuccess ?? result?.IsSuccess ?? true;

        const output = result?.output ?? result?.Output;

        const outputStatus = output?.status ?? output?.Status ?? "";

        const outputMessage = output?.message ?? output?.Message ?? "";

        const statusText = String(outputStatus).toLowerCase();

        const messageText = String(outputMessage).toLowerCase();

        const isDuplicate =

          statusText.includes("duplicate") ||

          statusText.includes("already") ||

          (messageText.includes("already") && messageText.includes("exist"));



        if (isDuplicate) {

          const duplicateMessage = outputMessage || "School already exists.";

          setError(duplicateMessage);

          showNotification("error", duplicateMessage);

          return;

        }



        if (isSuccess === false) {

          const apiMessage =

            outputMessage ||

            getErrorMessage(

              result,

              isEdit ? "Failed to update school." : "Failed to create school."

            );

          setError(apiMessage);

          showNotification("error", apiMessage);

          return;

        }



        const successMessage =















          typeof result === "string" &&















            result.trim()















            ? result















            : result?.message ||















            result?.Message ||















            (















              isEdit















                ? "School updated successfully!"















                : "School created successfully!"















            );































        showNotification(







          "success",







          successMessage







        );































        if (onSave) {















          await onSave(result);















        }































        if (onBack) {















          onBack();















        }































      } catch (err) {































        console.error(















          isEdit















            ? "Update School Error:"















            : "Create School Error:",















          err















        );































        const apiErrorData =







          err?.response?.data;















        const message =







          getErrorMessage(







            apiErrorData,







            err?.message ||







              (







                isEdit







                  ? "Unable to update school."







                  : "Unable to create school."







              )







          );















        setError(















          message















        );















        showNotification(







          "error",







          message







        );































      } finally {































        setSaving(















          false















        );















      }















    };































  const renderFieldError = (name) => {
    if (!fieldErrors?.[name]) return null;

    return (
      <div
        style={{
          color: "#dc2626",
          fontSize: 10.5,
          marginTop: 4,
        }}
      >
        {fieldErrors[name]}
      </div>
    );
  };

  return (















    <>































      <BC















        items={[















          "Schools",















          title,















        ]}















        onBack={















          onBack















        }















      />















      <div















        className="card cp"















        style={{















          maxWidth: 720,















        }}















      >















        <div















          style={{















            fontWeight: 700,















            fontSize: 15,















            marginBottom: 18,















          }}















        >















          {title}















        </div><div















          className="fsec"















        >































          <div















            className="fsec-t"















          >































            <I















              n="school"















              s={14}















              c="var(--p)"















            />































            School Information































          </div>















































          <div















            className="fgrid"















          > <div















            className="fg"















          >































              <label















                className="fl"















              >















                School Name *















              </label>































              <input















                className="fi"































                value={















                  f.name















                }































                onChange={















                  (event) =>















                    s(















                      "name",















                      event















                        .target















                        .value















                    )















                }































                placeholder="e.g. Ryan International School"















              />
              {renderFieldError("name")}































            </div><div















              className="fg"















            >































              <label















                className="fl"















              >















                State















              </label>































              <input















                className="fi"































                value={















                  f.state















                }































                readOnly































                placeholder="Maharashtra"















              />































            </div><div















              className="fg"















            >































              <label















                className="fl"















              >















                District *















              </label>































              <select















                className="fi"































                value={















                  f.districtId















                }































                onChange={















                  handleDistrictChange















                }































                disabled={















                  loadingDistricts















                }















              >















                <option















                  value=""















                >































                  {loadingDistricts















                    ? "Loading Districts..."















                    : "Select District"}































                </option>















                {districts.map(















                  (district) => (































                    <option















                      key={















                        district.id















                      }































                      value={















                        district.id















                      }















                    >































                      {















                        district.name















                      }































                    </option>































                  )















                )}































                              <option



                  value="__add_district__"



                  style={{



                    color: "#2563EB",



                    fontWeight: 600,



                  }}



                >



                  ＋ Add New District



                </option>







</select>
              {renderFieldError("districtId")}















            </div><div















              className="fg"















            >































              <label















                className="fl"















              >















                Taluka *















              </label>































              <select















                className="fi"































                value={















                  f.talukaId















                }































                onChange={(event) => {



                  if (



                    event.target.value ===



                    "__add_taluka__"



                  ) {



                    setAddTalukaOpen(true);



                    return;



                  }







                  s(



                    "talukaId",



                    event.target.value



                  );



                }}



                disabled={















                  !f.districtId ||















                  loadingTalukas















                }















              >















                <option















                  value=""















                >















                  {!f.districtId















                    ? "First Select District"















                    : loadingTalukas















                      ? "Loading Talukas..."















                      : currentTalukas.length === 0















                        ? "No Talukas Found"















                        : "Select Taluka"}































                </option>















                {currentTalukas.map(















                  (taluka) => (































                    <option















                      key={















                        taluka.id















                      }































                      value={















                        taluka.id















                      }















                    >































                      {















                        taluka.name















                      }































                    </option>































                  )















                )}































                              {f.districtId && (



                  <option



                    value="__add_taluka__"



                    style={{



                      color: "#2563EB",



                      fontWeight: 600,



                    }}



                  >



                    ＋ Add New Taluka



                  </option>



                )}







</select>
              {renderFieldError("talukaId")}















            </div> <div















              className="fg fall"















            >































              <label















                className="fl"















              >















                School Address















              </label>































              <input















                className="fi"































                value={















                  f.address















                }































                onChange={















                  (event) =>















                    s(















                      "address",















                      event















                        .target















                        .value















                    )















                }































                placeholder="Street, Area, City"















              />















            </div> <div















              className="fg"















            >































              <label















                className="fl"















              >















                Pincode















              </label>































              <input















                className="fi"































                value={















                  f.pincode















                }































                onChange={















                  (event) =>















                    s(















                      "pincode",































                      event















                        .target















                        .value















                        .replace(















                          /\D/g,















                          ""















                        )















                    )















                }































                placeholder="e.g. 415001"































                maxLength={















                  6















                }































                inputMode="numeric"















              />
              {renderFieldError("pincode")}































            </div>















          </div>















        </div><div















          className="fsec"















        >































          <div















            className="fsec-t"















          >















            <I















              n="person"















              s={14}















              c="var(--p)"















            />































            Contact Details































          </div>















          <div















            className="fgrid"















          >















            <div















              className="fg"















            >































              <label















                className="fl"















              >















                Phone















              </label>































              <input















                className="fi"































                value={















                  f.phone















                }































                onChange={















                  (event) =>















                    s(















                      "phone",































                      event















                        .target















                        .value















                        .replace(















                          /\D/g,















                          ""















                        )















                    )















                }































                maxLength={















                  10















                }































                inputMode="numeric"































                placeholder="Enter 10 digit phone number"















              />
              {renderFieldError("phone")}































            </div>































          </div>































        </div>















        <div















          style={{















            display:















              "flex",































            gap: 9,















          }}















        >















          <button















            type="button"































            className="btn btn-p"































            onClick={















              handleSubmit















            }































            disabled={















              saving ||















              loadingDistricts ||















              loadingTalukas















            }















          >































            <I















              n="check"















              s={13}















              c="#fff"















            />















































            {saving















              ? isEdit















                ? "Updating..."















                : "Saving..."















              : isEdit















                ? "Update School"















                : "Add School"}































          </button>















































          <button















            type="button"































            className="btn btn-g"































            onClick={















              onBack















            }































            disabled={















              saving















            }















          >































            Cancel































          </button>































        </div>































      </div>



































      {addDistrictOpen && (



        <div



          className="modal-bg"



          onClick={() =>



            setAddDistrictOpen(false)



          }



        >



          <div



            className="modal modal-sm"



            onClick={(event) =>



              event.stopPropagation()



            }



          >



            <div className="mhdr">



              <div className="mhdr-t">



                Add New District



              </div>







              <button



                type="button"



                className="xbtn"



                onClick={() =>



                  setAddDistrictOpen(false)



                }



              >



                <I n="x" s={13} />



              </button>



            </div>







            <div className="mbody">



              <div className="fg">



                <label className="fl">



                  District Name



                </label>







                <input



                  className="fi"



                  value={newDistrict}



                  onChange={(event) =>



                    setNewDistrict(



                      event.target.value



                    )



                  }



                  placeholder="Enter district name"



                  autoFocus



                  disabled={districtSaving}



                />



              </div>



            </div>







            <div className="mfoot">



              <button



                type="button"



                className="btn btn-g"



                onClick={() =>



                  setAddDistrictOpen(false)



                }



                disabled={districtSaving}



              >



                Cancel



              </button>







              <button



                type="button"



                className="btn btn-p"



                onClick={handleAddDistrict}



                disabled={districtSaving}



              >



                <I



                  n="check"



                  s={13}



                  c="#fff"



                />



                {districtSaving



                  ? "Adding..."



                  : "Add"}



              </button>



            </div>



          </div>



        </div>



      )}







      {addTalukaOpen && (



        <div



          className="modal-bg"



          onClick={() =>



            setAddTalukaOpen(false)



          }



        >



          <div



            className="modal modal-sm"



            onClick={(event) =>



              event.stopPropagation()



            }



          >



            <div className="mhdr">



              <div className="mhdr-t">



                Add New Taluka



              </div>







              <button



                type="button"



                className="xbtn"



                onClick={() =>



                  setAddTalukaOpen(false)



                }



              >



                <I n="x" s={13} />



              </button>

            </div>

            <div className="mbody">

              <div className="fg">

                <label className="fl">

                  District

                </label>

                <input

                  className="fi"

                  value={

                    districts.find(

                      (district) =>

                        Number(district.id) ===

                        Number(f.districtId)

                    )?.name || ""

                  }

                  readOnly

                />

              </div>

              <div className="fg">

                <label className="fl">

                  Taluka Name

                </label>

                <input

                  className="fi"

                  value={newTaluka}

                  onChange={(event) =>

                    setNewTaluka(

                      event.target.value

                    )

                  }

                  placeholder="Enter taluka name"

                  autoFocus

                  disabled={talukaSaving}

                />

              </div>

            </div>

            <div className="mfoot">

              <button

                type="button"

                className="btn btn-g"

                onClick={() =>

                  setAddTalukaOpen(false)

                }

                disabled={talukaSaving}

              >

                Cancel

              </button>

              <button

                type="button"

                className="btn btn-p"

                onClick={handleAddTaluka}

                disabled={talukaSaving}

              >

                <I

                  n="check"

                  s={13}

                  c="#fff"

                />

                {talukaSaving

                  ? "Adding..."

                  : "Add"}

              </button>

            </div>

          </div>

        </div>

      )}

</>

  );

}